// Inlined TitleCasePipe to avoid resolution issues in some environments
import { Pipe, PipeTransform } from '@angular/core';
import { CamelCaseToSentencePipe } from './camel-case-to-sentence-case.pipe';
@Pipe({ name: 'titleCase' })
export class TitleCasePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    value = CamelCaseToSentencePipe.prototype.transform(value);
    const words = value.trim().split(/\s+/);
    const result = words.map((word, idx) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
    return result;
  }
}